export function isIos () {
    return /ios|iphone|ipad|Mac/i.test(navigator.userAgent)
}

export function isWeixin () {
    return /MicroMessenger/i.test(navigator.userAgent)
}
